import React from 'react';

import PropTypes from 'prop-types';

import {
    Form,
    FormInput,
    Validate,
} from 'wanderu-component-form';
import {
    Button,
} from 'wanderu-components';
import {
    localize,
} from 'wanderu-i18n';

import baseAppConfig from '../../../config/baseApp.locales';

import styles from './SignUpForm.scss';

const PASSWORD_KEY = 'password';

function SignUpForm(props) {
    const {
        disabled,
        defaultValues,
        hasError,
        loading,
        t,
        onSubmit,
        onChange,
        onFocus,
        success,
    } = props;

    function removePasswordFromDefaults() {
        if (!defaultValues || !defaultValues[PASSWORD_KEY]) {
            return;
        }
        delete defaultValues[PASSWORD_KEY];
    }

    removePasswordFromDefaults();

    return (
        <Form
            defaultValues={defaultValues}
            hasError={hasError}
            onChange={onChange}
            onFocus={onFocus}
            onSuccess={onSubmit}
        >
            <Validate
                key="firstName"
                required
            >
                <FormInput
                    placeholder={t('first-name')}
                    type="text"
                />
            </Validate>
            <Validate
                key="lastName"
                required
            >
                <FormInput
                    placeholder={t('last-name')}
                    type="text"
                />
            </Validate>
            <Validate
                key="email"
                type="email"
                required
            >
                <FormInput
                    placeholder={t('email')}
                    type="email"
                />
            </Validate>
            <Validate
                key={PASSWORD_KEY}
                type="password"
                required
                showPasswordRequirements
            >
                <FormInput
                    placeholder={t('create-password')}
                    type="password"
                />
            </Validate>
            <Button
                className={styles.signUpButton}
                disabled={disabled}
                loading={loading}
                success={success}
                type="submit"
            >
                {t('sign-up-button')}
            </Button>
        </Form>
    );
}

SignUpForm.propTypes = {
    disabled: PropTypes.bool,
    t: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    success: PropTypes.bool,
};

SignUpForm.defaultProps = {
    disabled: false,
    onSubmit() {},
    onChange() {},
    onFocus() {},
    loading: false,
    success: false,
};

export { SignUpForm };
export default localize(SignUpForm, baseAppConfig.namespace);
